import { Button, MessageBox, MessageBoxType } from '@ui5/webcomponents-react';
import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';

export interface ConfirmationDialogProps {
  open: boolean;
  type: MessageBoxType;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  className?: string;
  [x: string]: any;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (props) => {
  const { t } = useTranslation();
  const { open, type, onClose, onConfirm, children, className, ...rest } = props;

  return createPortal(
    <MessageBox
      open={open}
      type={type}
      onClose={onClose}
      className={className}
      actions={[
        <Button
          key="confirm-ok"
          id="confirm-ok"
          data-testid="confirm-ok"
          onClick={onConfirm}
          design={ButtonDesign.Emphasized}
        >
          {t('confirm')}
        </Button>,
        <Button key="confirm-cancel" id="confirm-cancel" data-testid="confirm-cancel">
          {t('cancel')}
        </Button>
      ]}
      {...rest}
    >
      {children}
    </MessageBox>,
    document.body
  );
};
